<template>
    <nav class="menubar">
        <ul>
            <li>
                <router-link v-bind:class="{ active: active == 'home' }" :to="{ name: 'Home' }">
                    <template v-if="config.localeApp == 'se'">
                        Mu dieđáhusat
                    </template>
                    <template v-else>
                        Mine meldinger
                    </template>
                </router-link>
            </li>
            <li>
                <router-link v-bind:class="{ active: active == 'post' }" :to="{ name: 'Post' }">
                    <template v-if="config.localeApp == 'se'">
                        Čále ođđa dieđáhusa
                    </template>
                    <template v-else>
                        Skriv ny melding
                    </template>
                </router-link>
            </li>
            <li>
                <router-link v-bind:class="{ active: active == 'profile' }" :to="{ name: 'Profile' }">
                    <template v-if="config.localeApp == 'se'">
                        Rievdat beassansáni
                    </template>
                    <template v-else>
                        Brukerprofil
                    </template>
                </router-link>
            </li>
            <li>
                <a @click.prevent="logout">
                    <template v-if="config.localeApp == 'se'">
                        Olggosčálit iežat
                    </template>
                    <template v-else>
                        Logg ut
                    </template></a
                >
            </li>
        </ul>
    </nav>
</template>
<script>
import { config } from '../../volunteer/config/config';
export default {
    data() {
        return {
            config: config,
        };
    },
    props: {
        active: '',
    },
    methods: {
        logout() {
            var _this = this;
            this.$auth.logout({
                success() {},
                error() {},
            });
        },
    },
};
</script>
<style lang="scss">
.menubar {
    margin-left: rem-calc(30);

    @include breakpoint(large up) {
        margin-top: rem-calc(-10);
        margin-bottom: rem-calc(20);
    }

    ul {
        display: block;
        margin: 0 auto;
        padding: 0;
        list-style-type: none;

        @include breakpoint(large up) {
            display: flex;
            align-items: flex-start;
        }

        li {
            a {
                padding: rem-calc(0 5 5 5);
                color: #000;
                text-decoration: none;
                text-transform: uppercase;

                &:hover {
                    color: #000;
                    text-decoration: underline;
                }
                &.active {
                    text-decoration: underline;
                }
            }
        }

        @include breakpoint(large up) {
            li + li a {
                margin-left: rem-calc(20);
            }
            li:last-child {
                margin-left: auto;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Menu.vue